<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="m-1 flex-grow-1 overflow-auto">
            <div class="flex-grow-1 overflow-auto" style="padding: 1.25rem">
                <div class="mb-3-rem" style="display: none">
                    <v-label>{{ $t("res_Label_From")}} *</v-label>
                    <v-text-field solo v-model='dispatchValues.fromEmail'></v-text-field>
                </div>
                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_To")}} *</v-label>
                       <multi-select
                        v-model="dispatchValues.toEmails"
                        :options="structureUsers"
                        :multiple="true"
                        track-by="id"
                        label="name"
                        placeholder="Select or add values"
                        :searchable="true"
                        :allow-empty="true"
                        @search-change="getStructureUsers" 

                      ></multi-select>
                </div>
                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_CC")}}</v-label>
                    <multi-select
                        v-model="dispatchValues.EmailCC"
                        :options="structureUsersCC"
                        :multiple="true"
                        track-by="id"
                        label="name"
                        placeholder="Select or add values"
                        :searchable="true"
                        :allow-empty="true"
                        @search-change="getStructureUsersCC"
                        
                      ></multi-select>
                </div>

                <div class="mb-3-rem">
                    <v-label>{{ $t("res_Label_Subject")}} *</v-label>
                    <v-text-field solo v-model='dispatchValues.subject'></v-text-field>
                </div>

                <div class="mb-3-rem" v-if="attachments.length !== 0">
    <v-label>{{ $t("res_Label_Attachments")}}</v-label>
    <v-list>
        <v-list-item v-for="item in attachments" :key="item.id">
            <v-row align="center">
                <v-col cols="9">
                    <v-checkbox color="primary" v-model="dispatchValues.attachDocuments" :label="item.name" :value="item.id"></v-checkbox>
                </v-col>
                <v-col cols="3" class="text-right">{{ fileSizeInKB(item.fileSize) }} KB</v-col>
            </v-row>
        </v-list-item>
    </v-list>
</div>

                <div>
                    <v-label>{{ $t("res_Label_Body")}} *</v-label>
                    <McWysiwyg v-model="dispatchValues.body" :options="editorOptions" :key="trigger" />
                    <!-- <textarea class="text-area" style="height:100px;" v-model="dispatchValues.body"></textarea> -->
                </div>
            </div>
        </div>
        
        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="closeDialog">{{ $t("res_ButtonText_Cancel")}}</v-btn>
            <v-btn class="primary flex-1" @click="sendDispatch">{{ $t("res_ButtonText_Dispatch")}}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    import { McWysiwyg } from '@mycure/vue-wysiwyg'
    import constants from "@/assets/js/constants.js"
    import axios from "axios";
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'DispatchLetter',
        components: { McWysiwyg, MultiSelect },
        data: function () {
            return {
                loading: false,
                structureUsers:[],
                structureUsersCC:[],
                dispatchValues: {
                    fromEmail: '',
                    toEmails: [{ id: 0, name: '' }],
                    EmailCC: [{ id: 0, name: '' }],
                    subject: '',
                    recipient: '',
                    body: '',
                    attachDocuments: [],
                    template: '',
                    users: [],
                    recipients: [],
                },
                attachments: [],
                editorOptions: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // Basic font styles
                        [{ 'header': 1 }, { 'header': 2 }], // Headers
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
                        ['link', 'image', 'video'], // Media
                        ['clean'] // Remove formatting
                    ],
                    formats: ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link', 'image', 'video', 'font','table'],
                    fontNames: ['Arial', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New'],
                    fontSize: ['10px', '12px', '14px', '16px', '18px', '24px', '36px']
                },
                trigger: 1
            };
        },
        props: {
            documentId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
            withAttachments: { type: Boolean, default: false}, 
            transferId: { type: Number, default: 0 },
            documentSubject: { type: String, default: '' }
        },
        mounted ()
        {
            this.initForm()
        },
        methods: 
        {
            fileSizeInKB(bytes) {
            return (bytes / 1024).toFixed(2);
            },
            toEmailChanged(item){
                this.dispatchValues.toEmails=item
            },
            ccEmailChanged(item){
                this.dispatchValues.EmailCC=item
            },
            initForm()
            {
                var user = JSON.parse(sessionStorage.getItem("user"));
                this.dispatchValues.fromEmail = user.profile.Email;
                if(this.withAttachments)
                {
                    this.getAttachment()
                }
                this.getUsers("")
                this.getNotificationTemplate()
            },
            closeDialog() 
            {
                this.$emit('closeDialog')
            },
            getAttachment: async function ()
            {
                this.dispatchValues.attachDocuments = []
                await axios.get(constants.baseApiUrl + "Document/GetDocumentAttachments?documentId=" + this.documentId)
                    .then(response => 
                    {
                        response.data.forEach((element, index) => {
                            const myArray = element.name.split("_");
                            let obj = {}
                            obj.id = element.id;
                            obj.extension = element.extension;
                            obj.fileSize =element.fileSize
                            obj.name = index == 0 ? this.documentSubject : myArray[0]
                            obj.size = myArray[1];
                            this.attachments.push(obj)
                            this.dispatchValues.attachDocuments.push(element.id)
                        });
                    })
                    .catch(err => console.warn(err))
            },
            getNotificationTemplate()
            {
                this.dispatchValues.body = ''

                this.loading = true
                axios.get(constants.baseApiUrl + 'Letter/GetDispatchTemplate?documentId='+this.documentId+'&transferId=' + this.transferId)
                    .then(res => 
                    {
                        this.dispatchValues.body =  res.data.body;
                        this.dispatchValues.subject = res.data.subject; 
                    })
                    .catch(() => this.loading = false)
                    .finally(() => this.loading = false)
            },
            isValidEmail(email)
            {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            },
            getStructureUsers(query)
            {
                this.structureUsers = []
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&hideUsersWithNoEmails=true&search=';
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => {
                        this.structureUsers = res.data 
                        var isValidEmail = this.isValidEmail(query)
                        if(isValidEmail)
                        {
                          this.structureUsers.push({ id: Date.now(),name: query ,email: query })
                        }
                    //  if(res.data != null && res.data.length > 0)
                    })
                    .catch(err => console.warn(err))
            },
            getStructureUsersCC(query)
            {
                this.structureUsers = []
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&hideUsersWithNoEmails=true&search=';
                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => {
                        this.structureUsersCC = res.data
                        this.structureUsersCC.unshift({ id: Date.now(),name: query ,email: query });
                    })
                    .catch(err => console.warn(err))
            },
            sendDispatch: async function () 
            {
                if (this.dispatchValues.toEmails.length < 2 || this.dispatchValues.EmailCC.length < 0 || this.dispatchValues.subject == '' 
                        ||  this.dispatchValues.body == '' || this.dispatchValues.recipient) 
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                }
                else 
                {
                    var methodUrl = 'Letter/AddDispatchLetter';

                    var toEmails = "";
                    // Check if there's a null email
                    var nullEmailFound = this.dispatchValues.toEmails.find(toEmail => toEmail === null || toEmail.email === null);

                    if (nullEmailFound) {
                        window.showAlert(this.$t('res_Msgs_EmailDispatchedNotFound') + nullEmailFound.name, 'warning');
                        return; 
                    }

                    if (this.dispatchValues.toEmails.length > 0) {
                        // Extract emails and filter out undefined values
                    const validToEmails = this.dispatchValues.toEmails
                        .filter(toEmail => toEmail.id != 0 && toEmail.email)
                        .map(toEmail => toEmail.email);

                    // Join the valid emails with a comma and space
                    toEmails = validToEmails.join(", ");                 
                    }
                    var ccEmails = "";
                    if(this.dispatchValues.EmailCC.length>0)
                    {
                    // Extract emails and filter out undefined values
                    const validCCEmails = this.dispatchValues.EmailCC
                        .filter(ccEmail => ccEmail.id != 0 && ccEmail.email)
                        .map(ccEmail => ccEmail.email);

                    // Join the valid emails with a comma and space
                    ccEmails = validCCEmails.join(", ");
                     
                    }

                    var dispatchBody = {
                        DocumentId: this.documentId,
                        FromEmail: this.dispatchValues.fromEmail,
                        ToEmail: toEmails,
                        Ccemails: ccEmails,
                        Subject: this.dispatchValues.subject,
                        Body: this.dispatchValues.body,
                        StorageAttachmentIds: this.dispatchValues.attachDocuments.join(', ')
                    }

                    axios.post(constants.baseApiUrl + methodUrl, dispatchBody, { headers: constants.headers })
                        .then(res => {
                            
                            if(res.data != null && res.data == "Success"){
                                window.showAlert('res_Msgs_EmailDispatched', 'success')
                                this.closeDialog();
                            }
                            else
                                window.showAlert('res_Msgs_Warning', 'warning')
                        })
                        .catch(err => console.warn(err))
                }
            },
            clearData: function () 
            {
                var user = JSON.parse(sessionStorage.getItem("user"));
                
                this.dispatchValues = {
                    fromEmail: user.profile.Email,
                    toEmails: { type: Array, default: () => [] },
                    EmailCC: { type: Array, default: () => [] },
                    subject: "",
                    recipient: "",
                    body: "",
                    attachDocuments: [],
                    template: "",
                    users: [],
                    recipients: []
                }

                this.attachments = []
                this.trigger++
            }
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.initForm()
                    else
                        this.clearData()
                }
            }
        },
    }
</script>

<style>
    .v-icon.v-icon.v-icon--link {
        cursor: pointer;
        outline: none;
        left: 0% !important;
        position: relative !important;
    }
    /* .v-list-item:hover {
        background-color: transparent !important;
      } */
</style>